var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"copyright"},[_vm._v("\n  "+_vm._s(_vm.copLabel)+" © "+_vm._s(_vm.copYear)+"\n  "),_c('span',[_vm._v(_vm._s(_vm.copDesc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }